module.exports = __webpack_public_path__ + "img/vegetable-sorrel-190x100.5bcd97f3.jpg";